// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__33Oeb","search":"Settings_search__12iTJ","filter":"Settings_filter__P0yLi"};